import * as $ from 'jquery';

export class ProductsCommon {

    static init() {
        $(document).off('click', '.product-card-component [data-details-url]');
        $(document).on('click', '.product-card-component [data-details-url]', function (ev) {
            let target = $(this);
            if (target.attr('data-details-url') && $(ev.target).closest('.product-card-icons').length==0) 
                window.location.href = target.attr('data-details-url');
        });
    }
} 